import { useEffect, useRef, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Copyright from "../../components/Copyright";
import { theme, drawerWidth } from "./config";
import apis from "../../apis";
import { toast } from "react-toastify";
import notificationSound from "../../assets/notification.mp3";

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const isSmUp = useMediaQuery(theme.breakpoints.up("md"));

  const audioRef = useRef(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const response = await apis.booking.checkNewBookings();
        if (response.count > 0) {
          toast.info(
            `Vừa có ${response.count} đặt lịch mới. Vui lòng kiểm tra ngay!`,
            {
              autoClose: false,
            }
          );
          audioRef.current?.play();
        }
      } catch (error) {
        console.error("Error checking new bookings:", error);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <CssBaseline />
        <Box
          component="nav"
          sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
        >
          {isSmUp ? null : (
            <Sidebar
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            />
          )}

          <Sidebar
            PaperProps={{ style: { width: drawerWidth } }}
            sx={{ display: { md: "block", sm: "none", xs: "none" } }}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Header onDrawerToggle={handleDrawerToggle} />
          <Box component="main" sx={{ flex: 1, bgcolor: "#ffffff" }}>
            {children}
          </Box>
          <Box component="footer" sx={{ p: 2, bgcolor: "#ffffff" }}>
            <Copyright />
          </Box>
        </Box>
        <audio ref={audioRef} src={notificationSound} preload="auto" />
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
